import { useEffect } from 'react';
import { fetchShipmentByNumber } from '../services/api';
import { defaultShipmentData } from '../dataSets/defaultFormData';

export const useInitialDataLoad = (shipmentNumber, setFormData, setIsLoading, setIsNew, delay) => {
  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      // Set isNew based on shipment number
      if (setIsNew) {
        setIsNew(shipmentNumber === 'nouveau');
      }

      if (shipmentNumber === 'nouveau') {
        if (!cancelled) {
          setFormData(defaultShipmentData);
          setIsLoading(false);
        }
      } else if (shipmentNumber) {
        try {
          const fetchedData = await fetchShipmentByNumber(shipmentNumber);

          if (!cancelled) {
            // Merger les données en préservant la structure
            setFormData(prevFormData => {
              const updatedFormData = {};
              Object.keys(prevFormData).forEach(key => {
                updatedFormData[key] =
                  fetchedData[key] !== undefined && fetchedData[key] !== null
                    ? fetchedData[key]
                    : prevFormData[key];
              });
              return updatedFormData;
            });

            // Délai pour l'UX puis arrêt du loading
            if (delay) {
              await delay(200);
            }

            if (!cancelled) {
              setIsLoading(false);
            }
          }
        } catch (error) {
          console.error('Erreur lors de la récupération du dossier:', error);
          if (!cancelled) {
            setIsLoading(false);
          }
        }
      }
    };

    fetchData();

    return () => {
      cancelled = true;
    };
  }, [shipmentNumber]);
};
